import { render, staticRenderFns } from "./OfferGoalsTab.vue?vue&type=template&id=7352333d&"
import script from "./OfferGoalsTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferGoalsTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferGoalsTab.vue?vue&type=style&index=0&id=7352333d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports